;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="d6e6f302-305f-4499-8759-5a246a1d6f21",e._sentryDebugIdIdentifier="sentry-dbid-d6e6f302-305f-4499-8759-5a246a1d6f21")}catch(e){}}();
{
  var _sentryModuleMetadataGlobal =
    typeof window !== "undefined"
      ? window
      : typeof global !== "undefined"
      ? global
      : typeof self !== "undefined"
      ? self
      : {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata =
    _sentryModuleMetadataGlobal._sentryModuleMetadata || {};

  _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack] =
    Object.assign(
      {},
      _sentryModuleMetadataGlobal._sentryModuleMetadata[new _sentryModuleMetadataGlobal.Error().stack],
      {"_sentryBundlerPluginAppKey:petsdeli-sentry":true}
    );
}
"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8563],{

/***/ 61118:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgCart(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M17.4 5.4a.42.42 0 00-.43-.39h-2.93V4c0-2.2-1.81-4-4.04-4a4.02 4.02 0 00-4.04 4v1.01H3.03c-.22 0-.4.17-.42.39L1.5 19.55a.42.42 0 00.42.45h16.14c.12 0 .23-.05.32-.13.08-.1.12-.2.1-.32L17.4 5.4zM7.23 4c0-1.5 1.24-2.74 2.76-2.74A2.75 2.75 0 0112.76 4v1.01H7.24V4zm6.8 3.75c0 2.2-1.81 4-4.04 4a4.02 4.02 0 01-4.04-4v-.38c0-.35.29-.63.64-.63.35 0 .64.28.64.63v.38c0 1.5 1.24 2.73 2.76 2.73a2.75 2.75 0 002.76-2.73v-.38c0-.35.29-.63.64-.63.35 0 .64.28.64.63v.38z",
    fill: "currentColor"
  })));
}
/* harmony default export */ __webpack_exports__["Z"] = (SvgCart);

/***/ }),

/***/ 74127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "p6": function() { return /* binding */ createAddress; },
  "_N": function() { return /* binding */ deleteAddress; },
  "Te": function() { return /* binding */ fetchCustomer; },
  "bT": function() { return /* binding */ fetchInvoice; },
  "gP": function() { return /* binding */ fetchOrderDetails; },
  "AU": function() { return /* binding */ fetchOrders; },
  "y3": function() { return /* binding */ updateAddress; }
});

// UNUSED EXPORTS: pushSegmentation

// EXTERNAL MODULE: ./src/utils/axios.ts
var axios = __webpack_require__(21744);
// EXTERNAL MODULE: ./src/models/address/index.ts
var models_address = __webpack_require__(90741);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(14251);
// EXTERNAL MODULE: ./node_modules/next/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(52875);
;// CONCATENATED MODULE: ./src/models/order/index.ts



var orderShortDetailsFromServerFormat = function(order) {
    return {
        id: order.id,
        number: order.number,
        createdAt: order.createdAt * 1000,
        financialStatus: order.financialStatus,
        fulfillmentStatus: order.fulfillmentStatus,
        totalPrice: order.totalPrice,
        shippingMethod: order.shippingMethod
    };
};
var ordersFromServerFormat = function(orders) {
    return orders.map(orderShortDetailsFromServerFormat);
};
var shippingFromServerFormat = function(shipping) {
    return {
        trackingNumber: shipping.trackingNumber,
        currencyCode: shipping.currencyCode,
        method: shipping.method,
        price: shipping.price
    };
};
var orderDetailsFromServerFormat = function(orderDetails) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, orderShortDetailsFromServerFormat(orderDetails)), {
        shippingAddress: models_address/* fromServerFormat */.nO(orderDetails.shippingAddress),
        billingAddress: orderDetails.billingAddress && models_address/* fromServerFormat */.nO(orderDetails.billingAddress),
        items: orderDetails.items,
        totalPrice: orderDetails.totalPrice,
        totalTax: orderDetails.totalTax,
        discount: orderDetails.discount,
        totalShippingPrice: orderDetails.shipping.price,
        shipping: shippingFromServerFormat(orderDetails.shipping),
        fulfillmentsUpdatedAt: orderDetails.fulfillmentsUpdatedAt
    });
};

;// CONCATENATED MODULE: ./src/api/customer.ts



var fetchCustomer = function(customerId) {
    return axios/* axios.get */.od.get("".concat("https://api.petsdeli.de/account", "/customer/").concat(customerId)).then(function(param) {
        var data = param.data;
        return data;
    });
};
var updateAddress = function(customerId, address) {
    return axios/* axios.post */.od.post("".concat("https://api.petsdeli.de/account", "/address/").concat(customerId), models_address/* toServerFormat */.CK(address)).then(function(param) {
        var data = param.data;
        return models_address/* fromServerFormat */.nO(data);
    });
};
var createAddress = updateAddress;
var deleteAddress = function(customerId, addressId) {
    return axios/* axios.delete */.od["delete"]("".concat("https://api.petsdeli.de/account", "/address/").concat(customerId), {
        data: {
            id: addressId
        }
    });
};
var fetchOrders = function(customerId) {
    return axios/* axios.get */.od.get("".concat("https://api.petsdeli.de/account", "/account/").concat(customerId, "/orders")).then(function(param) {
        var data = param.data;
        return data;
    }).then(ordersFromServerFormat);
};
var fetchOrderDetails = function(customerId, orderId) {
    return axios/* axios.get */.od.get("".concat("https://api.petsdeli.de/account", "/account/").concat(customerId, "/orders/").concat(orderId)).then(function(param) {
        var data = param.data;
        return data;
    }).then(orderDetailsFromServerFormat);
};
/**
 * fetch user's invoice of a order.
 * @param {number} customerId The id of the customer.
 * @param {number} orderId The id of the order.
 * @returns {Promise}
 */ var fetchInvoice = function(customerId, orderId) {
    return axios/* axios.get */.od.get("".concat("https://api.petsdeli.de/account", "/").concat(customerId, "/orders/").concat(orderId, "/invoice")).then(function(param) {
        var data = param.data;
        return data;
    });
};
/**
 * Push segmentation for customer session.
 * @TODO : stub
 * @TODO : Add docs about how it works
 */ var pushSegmentation = function(param) {
    var segmentation = param.segmentation;
    return Promise.resolve("okay");
};


/***/ }),

/***/ 71209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ useCustomerDetails; }
/* harmony export */ });
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);
/* harmony import */ var _api_customer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74127);


var useCustomerDetails = function(customerId) {
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function() {
        if ( false || !customerId) {
            return null;
        }
        return String(customerId);
    }, function() {
        if (!customerId) {
            return Promise.resolve(undefined);
        }
        return _api_customer__WEBPACK_IMPORTED_MODULE_1__/* .fetchCustomer */ .Te(customerId);
    }), data = ref.data, isValidating = ref.isValidating, mutate = ref.mutate;
    return {
        details: data,
        loading: isValidating,
        refetch: function() {
            return mutate(function() {
                if (!customerId) {
                    return Promise.resolve(undefined);
                }
                return _api_customer__WEBPACK_IMPORTED_MODULE_1__/* .fetchCustomer */ .Te(customerId);
            });
        }
    };
};


/***/ }),

/***/ 48563:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ customer_links; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/contexts/auth/index.tsx + 8 modules
var auth = __webpack_require__(62799);
// EXTERNAL MODULE: ./src/contexts/cart.tsx + 4 modules
var cart = __webpack_require__(15731);
// EXTERNAL MODULE: ./src/contexts/pet.tsx
var pet = __webpack_require__(75556);
// EXTERNAL MODULE: ./src/hooks/customer/use-customer.ts
var use_customer = __webpack_require__(71209);
// EXTERNAL MODULE: ./src/hooks/test/use-dynamic-ux/index.tsx
var use_dynamic_ux = __webpack_require__(9867);
// EXTERNAL MODULE: ./src/modules/header/search/index.tsx + 2 modules
var search = __webpack_require__(12739);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/useIntl.js
var useIntl = __webpack_require__(86896);
// EXTERNAL MODULE: ./node_modules/react-intl/lib/src/components/message.js
var message = __webpack_require__(44012);
// EXTERNAL MODULE: ./src/assets/icons/cart.svg
var icons_cart = __webpack_require__(61118);
;// CONCATENATED MODULE: ./src/assets/icons/user-minimal.svg
var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function SvgUserMinimal(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#user-minimal_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/react.createElement("path", {
    d: "M12 12.704a6.351 6.351 0 10-6.352-6.352A6.36 6.36 0 0012 12.704zm0-10.812a4.459 4.459 0 11-4.46 4.46A4.464 4.464 0 0112 1.895v-.003zM1.93 25.811c0-5.553 4.517-10.07 10.07-10.07s10.07 4.517 10.07 10.07h1.895a11.965 11.965 0 00-20.425-8.46 11.886 11.886 0 00-3.505 8.46H1.93z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "user-minimal_svg__a"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
}
/* harmony default export */ var user_minimal = (SvgUserMinimal);
// EXTERNAL MODULE: ./src/tracking/index.ts
var tracking = __webpack_require__(1975);
// EXTERNAL MODULE: ./src/contexts/dom.tsx
var dom = __webpack_require__(98653);
;// CONCATENATED MODULE: ./src/modules/header/floating-indicator/index.tsx


var FloatingIndicator = function(param) {
    var count = param.count, id = param.id, _theme = param.theme, theme = _theme === void 0 ? "light" : _theme;
    return count !== 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        "data-test": "cartamount",
        id: id,
        className: "absolute -right-0 -top-1 flex h-4 w-4 items-center justify-center rounded-full pt-px text-center text-xxs font-black lg:-right-2 lg:text-xs ".concat(theme === "light" ? "bg-primary-main text-other-white lg:bg-other-white lg:text-primary-main " : "bg-other-white text-primary-main lg:bg-primary-main lg:text-other-white "),
        children: count
    }) : null;
};
/* harmony default export */ var floating_indicator = (FloatingIndicator);

// EXTERNAL MODULE: ./src/assets/icons/magazine.svg
var magazine = __webpack_require__(17033);
// EXTERNAL MODULE: ./src/assets/icons/phone-2.svg
var phone_2 = __webpack_require__(93352);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./src/components/pet-profile/mobile-navigation-link/index.tsx
var mobile_navigation_link = __webpack_require__(88477);
// EXTERNAL MODULE: ./src/constants/feature-flag.ts
var feature_flag = __webpack_require__(93841);
// EXTERNAL MODULE: ./src/constants/segmentation.ts
var constants_segmentation = __webpack_require__(6813);
// EXTERNAL MODULE: ./src/contexts/segmentation.tsx + 3 modules
var segmentation = __webpack_require__(42067);
// EXTERNAL MODULE: ./src/contexts/tracking.tsx + 1 modules
var contexts_tracking = __webpack_require__(70315);
// EXTERNAL MODULE: ./src/hooks/common/use-lock-body-scroll.ts
var use_lock_body_scroll = __webpack_require__(56238);
// EXTERNAL MODULE: ./src/hooks/navigation/use-navigation-data.ts + 6 modules
var use_navigation_data = __webpack_require__(71543);
// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
// EXTERNAL MODULE: ./src/assets/icons/chevron-left-stroke.svg
var chevron_left_stroke = __webpack_require__(88363);
// EXTERNAL MODULE: ./src/assets/icons/menu-close.svg
var menu_close = __webpack_require__(77217);
// EXTERNAL MODULE: ./src/assets/icons/menu.svg
var menu = __webpack_require__(87521);
// EXTERNAL MODULE: ./src/modules/header/nav/navigation-link/index.tsx
var navigation_link = __webpack_require__(82995);
;// CONCATENATED MODULE: ./src/modules/header/nav/mobile/mobile-test.tsx






















var ComponentName = "Navigation";
// Common button styles for navigation tabs
var NAV_TAB_BUTTON_CLASSES = "h-16 w-1/3 pt-1 font-black capitalize focus:outline-none";
var NAV_TAB_TEXT_CLASSES = "relative border-other-white text-base text-other-white";
var CLOSE_BUTTON_CLASSES = "h-6 w-6 cursor-pointer text-text-dark-bg-contrast-white";
/**
 * Navigation header with pet type tabs and close button
 */ var NavigationHeader = /*#__PURE__*/ (0,react.memo)(function(param) {
    var petType = param.petType, setPetType = param.setPetType, onClose = param.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var handleDogClick = (0,react.useCallback)(function() {
        (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
            element: [
                ComponentName,
                intl.formatMessage({
                    id: "header:navigation-dogs"
                }), 
            ]
        }));
        setPetType("dogs");
    }, [
        intl,
        setPetType
    ]);
    var handleCatClick = (0,react.useCallback)(function() {
        (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
            element: [
                ComponentName,
                intl.formatMessage({
                    id: "header:navigation-cats"
                }), 
            ]
        }));
        setPetType("cats");
    }, [
        intl,
        setPetType
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full text-center text-sm uppercase tracking-wide text-other-black",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "relative flex bg-primary-main",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "absolute right-4 top-0 flex h-full items-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_close/* default */.Z, {
                        className: CLOSE_BUTTON_CLASSES,
                        onClick: onClose
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex w-full",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "data-test": "mobile-nav-dogs",
                            className: NAV_TAB_BUTTON_CLASSES,
                            onClick: handleDogClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: classnames_default()(NAV_TAB_TEXT_CLASSES, petType !== "dogs" && "text-grey-125"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "header:navigation-dogs"
                                    }),
                                    petType === "dogs" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute left-0 top-full h-1 w-full rounded-lg border border-other-white bg-other-white"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            "data-test": "mobile-nav-cats",
                            className: NAV_TAB_BUTTON_CLASSES,
                            onClick: handleCatClick,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: classnames_default()(NAV_TAB_TEXT_CLASSES, petType !== "cats" && "text-grey-125"),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "header:navigation-cats"
                                    }),
                                    petType === "cats" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "absolute left-0 top-full h-1 w-full rounded-lg border border-other-white bg-other-white"
                                    })
                                ]
                            })
                        })
                    ]
                })
            ]
        })
    });
});
NavigationHeader.displayName = "NavigationHeader";
/**
 * Subcategory navigation header with back button and close button
 */ var SubNavHeader = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onBack = param.onBack, onClose = param.onClose;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative bg-primary-main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute right-4 top-0 flex h-16 items-center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_close/* default */.Z, {
                    className: CLOSE_BUTTON_CLASSES,
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "flex h-16 w-full items-center bg-primary-main py-5 pl-4 pr-3 font-normal text-other-white focus:outline-none",
                onClick: onBack,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chevron_left_stroke/* default */.Z, {
                        className: "h-6 w-4"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                        id: "header:navigation:mobile:back"
                    })
                ]
            })
        ]
    });
});
SubNavHeader.displayName = "SubNavHeader";
/**
 * Footer with magazine and consulting links
 */ var NavigationFooter = /*#__PURE__*/ (0,react.memo)(function(param) {
    var onClose = param.onClose;
    var intl = (0,useIntl/* default */.Z)();
    var handleMagazineClick = (0,react.useCallback)(function() {
        (0,tracking/* selectElement */.G7)({
            element: [
                ComponentName,
                intl.formatMessage({
                    id: "header:navigation:mobile:magazine"
                }), 
            ]
        });
        onClose();
    }, [
        intl,
        onClose
    ]);
    var handleConsultingClick = (0,react.useCallback)(function() {
        (0,tracking/* selectElement */.G7)({
            element: [
                ComponentName,
                intl.formatMessage({
                    id: "header:navigation:mobile:consulting"
                }), 
            ]
        });
        onClose();
    }, [
        intl,
        onClose
    ]);
    var showMagazine = (0,feature_flag/* getFeatureFlag */.O)(feature_flag/* FeatureFlag.magazin */.T.magazin);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "absolute bottom-0 flex w-full items-center justify-between bg-grey-50 p-4 text-primary-main",
        children: [
            showMagazine && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/magazin",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: "mx-2 flex h-8 w-2/3 items-center justify-center rounded-lg border border-primary-main bg-other-white px-2 py-1 text-sm font-medium",
                    onClick: handleMagazineClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(magazine/* default */.Z, {
                            className: "mr-2 w-5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "header:navigation:mobile:magazine"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/pages/unsere-futterberatung-online-und-telefonisch",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: classnames_default()("mx-2 flex h-8 w-2/3 items-center justify-center rounded-lg border border-primary-main bg-other-white px-2 py-1 text-sm font-medium", showMagazine ? "w-2/3" : "w-full"),
                    onClick: handleConsultingClick,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(phone_2/* default */.Z, {
                            className: "mr-2 w-5"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "header:navigation:mobile:consulting"
                        })
                    ]
                })
            })
        ]
    });
});
NavigationFooter.displayName = "NavigationFooter";
/**
 * Navigation item component for rendering navigation links
 */ var NavigationItemComponent = /*#__PURE__*/ (0,react.memo)(function(param) {
    var item = param.item, index = param.index, className = param.className, currentPetType = param.currentPetType, currentSubNav = param.currentSubNav, setSubNav = param.setSubNav, setVisibility = param.setVisibility;
    var intl = (0,useIntl/* default */.Z)();
    var trackHotjarEvent = (0,contexts_tracking/* useTrackingContext */.E)().trackHotjarEvent;
    var ref = (0,segmentation/* useSegmentationContext */.M)(), pushSegmentation = ref.pushSegmentation, getSegmentationFromUrl = ref.getSegmentationFromUrl;
    var rootLabel = intl.formatMessage({
        id: "header:navigation-".concat(currentPetType)
    });
    var handleClick = function() {
        if (item.itemType === "entry" || item.itemType === "card") {
            setVisibility(false);
        } else {
            setSubNav(item);
        }
        if ("url" in item && item.url) {
            var segmentation = getSegmentationFromUrl({
                url: item.url
            });
            if (segmentation) {
                pushSegmentation({
                    segmentation: segmentation.id
                });
            }
            (0,constants_segmentation/* isSegmentationLink */._O)(item.url) && trackHotjarEvent();
        }
        if (item.title) {
            (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                element: currentSubNav ? [
                    ComponentName,
                    rootLabel,
                    String(currentSubNav.title),
                    item.title, 
                ] : [
                    ComponentName,
                    rootLabel,
                    item.title
                ]
            }));
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(navigation_link/* default */.Z, {
        item: item,
        className: className,
        onClick: handleClick
    }, index);
});
NavigationItemComponent.displayName = "NavigationItemComponent";
/**
 * Test component for the mobile navigation
 * In the case this variant will win the AB test, we will need to add the translation for the menu button
 * and also move the sub-components to separate files
 */ var MobileTest = function(param) {
    var className = param.className;
    var ref = (0,react.useState)(false), visible = ref[0], setVisibility = ref[1];
    var ref1 = (0,use_dynamic_ux/* default */.Z)(), loading = ref1.loading, showDynamicUx = ref1.showDynamicUx;
    var mobile = (0,use_navigation_data/* default */.Z)().mobile;
    var current = (0,pet/* usePetContext */.w)().current;
    var ref2 = (0,react.useState)("dogs"), petType = ref2[0], setPetType = ref2[1];
    var ref3 = (0,react.useState)(null), subNav = ref3[0], setSubNav = ref3[1];
    (0,use_lock_body_scroll/* default */.Z)(visible);
    (0,react.useEffect)(function() {
        if (current !== false) {
            setPetType(current);
        }
    }, [
        current
    ]);
    var handleClose = (0,react.useCallback)(function() {
        setVisibility(false);
        setSubNav(null);
    }, []);
    var handleBackClick = (0,react.useCallback)(function() {
        setSubNav(null);
    }, []);
    // Create a memoized function to render navigation items
    var navigationItem = (0,react.useCallback)(function(className, currentPetType, currentSubNav) {
        // eslint-disable-next-line react/display-name
        var renderItem = function(item, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationItemComponent, {
                item: item,
                index: index,
                className: className,
                currentPetType: currentPetType,
                currentSubNav: currentSubNav,
                setSubNav: setSubNav,
                setVisibility: setVisibility
            }, index);
        };
        return renderItem;
    }, [
        setSubNav,
        setVisibility
    ]);
    var navigationTree = (0,react.useCallback)(function(pet) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex grow flex-col overflow-x-hidden overflow-y-scroll",
                children: [
                    showDynamicUx && !loading && pet === "dogs" && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_navigation_link/* default */.Z, {
                        setVisibility: setVisibility
                    }),
                    mobile[pet].map(function(nav, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "-mt-2 h-1 bg-background-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "bg-other-white pb-16 pt-4",
                                    children: nav.map(navigationItem("font-black", pet))
                                })
                            ]
                        }, index);
                    })
                ]
            })
        });
    }, [
        mobile,
        navigationItem,
        showDynamicUx,
        loading,
        setVisibility
    ]);
    var handleMenuClick = (0,react.useCallback)(function() {
        if (!visible) {
            (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
                element: ComponentName
            }));
        }
        setVisibility(function(prevVisible) {
            return !prevVisible;
        });
    }, [
        visible
    ]);
    var navigation = (0,react.useMemo)(function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    "data-test": "mobile-navigation",
                    className: classnames_default()("top-124 fixed bottom-0 right-0 z-mobile-navigation flex h-full w-10/12 transform flex-col items-stretch justify-between overflow-hidden overflow-x-hidden bg-other-white shadow-[-10px_0_10px_0_rgba(0,0,0,0.25)] transition-transform duration-300 ease-in-out lg:hidden", visible ? "translate-x-0" : "translate-x-full"),
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationHeader, {
                            petType: petType,
                            setPetType: setPetType,
                            onClose: handleClose
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative flex flex-grow overflow-y-auto overflow-x-hidden",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("absolute inset-0 flex h-full min-w-full transform flex-col bg-other-white transition-transform duration-300 ease-in-out", petType === "cats" ? "-translate-x-full" : "translate-x-0"),
                                    children: navigationTree("dogs")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: classnames_default()("absolute inset-0 flex h-full min-w-full transform flex-col bg-other-white transition-transform duration-300 ease-in-out", petType === "cats" ? "translate-x-0" : "translate-x-full"),
                                    children: navigationTree("cats")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classnames_default()("absolute top-0 z-10 h-full min-w-full transform overflow-auto bg-other-white leading-[1.4rem] transition-transform duration-300 ease-in-out", subNav === null && "translate-x-full"),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(SubNavHeader, {
                                    onBack: handleBackClick,
                                    onClose: handleClose
                                }),
                                petType && subNav !== null && (subNav.itemType === "nested-card" || subNav.itemType === "nested-entry") && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: subNav.items && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "py-4",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "mb-2 px-4 text-lg font-black text-primary-main",
                                                children: subNav.title
                                            }),
                                            subNav.items.map(navigationItem("px8", petType, subNav))
                                        ]
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(NavigationFooter, {
                            onClose: handleClose
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    "data-test": "modal-backdrop",
                    className: classnames_default()("fixed inset-0 z-mobile-navigation-backdrop bg-background-tile-dark transition-opacity duration-300 ease-in-out lg:hidden", visible ? "opacity-50" : "pointer-events-none opacity-0"),
                    onClick: handleClose
                })
            ]
        });
    }, [
        petType,
        subNav,
        visible,
        navigationTree,
        navigationItem,
        handleClose,
        handleBackClick, 
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                "aria-label": "Navigation auf oder zuklappen",
                className: classnames_default()(className, "relative flex h-9 flex-col items-center justify-center leading-none text-grey-700 text-opacity-60 hover:text-grey-700 hover:text-opacity-80 focus:outline-none lg:hidden"),
                onClick: handleMenuClick,
                children: [
                    visible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(menu_close/* default */.Z, {
                        className: "w-6 shrink-0 text-primary-main lg:w-7 lg:text-text-dark-bg-contrast-white"
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(menu/* default */.Z, {
                        className: "w-6 shrink-0 text-primary-main lg:w-7 lg:text-text-dark-bg-contrast-white"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "text-xxs font-medium leading-4 text-primary-main lg:text-text-dark-bg-contrast-white",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                            id: "Men\xfc"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ react_dom.createPortal(navigation, document.body)
        ]
    });
};
/* harmony default export */ var mobile_test = (MobileTest);

;// CONCATENATED MODULE: ./src/modules/header/nav/customer-links/index.tsx


















var PetProfileNavbarLink = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 4001).then(__webpack_require__.bind(__webpack_require__, 4001));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4001)
            ];
        }
    },
    ssr: false
});
var CustomerLinks = function(param) {
    var isExperimentLoading = param.isExperimentLoading, variant = param.variant;
    var intl = (0,useIntl/* default */.Z)();
    var ref = (0,dom/* useDom */.h)(), headerCartIconRef = ref.headerCartIconRef, headerAccountIconRef = ref.headerAccountIconRef;
    var ref1 = (0,auth/* useAuth */.aC)(), isUserLoggedIn = ref1.isUserLoggedIn, customer = ref1.customer;
    var customerId = isUserLoggedIn ? customer === null || customer === void 0 ? void 0 : customer.customerId : undefined;
    var details = (0,use_customer/* useCustomerDetails */.S)(customerId).details;
    var firstName = details === null || details === void 0 ? void 0 : details.firstName;
    var ref2 = (0,use_dynamic_ux/* default */.Z)(), loading = ref2.loading, showDynamicUx = ref2.showDynamicUx;
    var current = (0,pet/* usePetContext */.w)().current;
    var pathname = (0,router.useRouter)().pathname;
    var itemsCount = (0,cart/* useCart */.j)().itemsCount;
    var trackingFunction = function(element) {
        (0,tracking/* gtm */.wT)((0,tracking/* selectElement */.G7)({
            element: [
                "Header",
                element
            ]
        }));
    };
    /**
   * Handles clicks on the account icon/link.
   * Prevents default navigation and layout shift when already on the login page.
   */ var handleAccountClick = function(e) {
        if (pathname === "/login") {
            e.preventDefault();
            return;
        }
        trackingFunction("Account");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex items-center gap-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative z-search h-[36px] lg:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(search/* default */.Z, {})
                }),
                current !== "cats" && showDynamicUx && !loading && /*#__PURE__*/ (0,jsx_runtime.jsx)(PetProfileNavbarLink, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/account",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        ref: headerAccountIconRef,
                        "data-test": "nav-account",
                        title: intl.formatMessage({
                            id: "header:account"
                        }),
                        className: "relative flex h-9 flex-col items-center justify-center leading-none text-grey-700/60 hover:text-grey-700 hover:text-grey-700/80",
                        onClick: handleAccountClick,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(user_minimal, {
                                className: "w-6 shrink-0 text-primary-main lg:w-7 lg:text-text-dark-bg-contrast-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "text-xxs font-medium leading-4 text-primary-main lg:text-text-dark-bg-contrast-white",
                                children: [
                                    isUserLoggedIn && firstName && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "header:account:greeting",
                                        values: {
                                            firstName: firstName
                                        }
                                    }),
                                    !isUserLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                        id: "header:account"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/cart",
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        ref: headerCartIconRef,
                        "data-test": "nav-cart",
                        title: intl.formatMessage({
                            id: "header:cart"
                        }),
                        className: "relative flex h-9 flex-col items-center justify-center leading-none text-grey-700/60 hover:text-grey-700 hover:text-grey-700/80",
                        onClick: function() {
                            return trackingFunction("Cart");
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(icons_cart/* default */.Z, {
                                className: "w-6 shrink-0 text-primary-main lg:w-7 lg:text-text-dark-bg-contrast-white"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(floating_indicator, {
                                count: itemsCount
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text-xxs font-medium leading-4 text-primary-main lg:text-text-dark-bg-contrast-white",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(message/* default */.Z, {
                                    id: "header:cart"
                                })
                            })
                        ]
                    })
                }),
                variant === 1 && !isExperimentLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile_test, {})
            ]
        })
    });
};
/* harmony default export */ var customer_links = (CustomerLinks);


/***/ })

}]);